import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { Modal } from "@cxagroup/casper";
import { Button } from "cxa-components";
import messages from "components/messagesDescription";

export const ConfirmationDialog = ({ instructions, isOpen, handleOk, handleCancel }) => (
  <Modal isOpen={isOpen} onRequestClose={close} contentLabel="Claim Instructions">
    <div className="modal__body">
      <p>{instructions}</p>
      <hr />
    </div>
    <div className="modal__footer">
      <Button type="button" secondary onClick={handleOk}>
        <FormattedMessage {...messages.okTextDescription} />
      </Button>
      <Button type="button" secondary onClick={handleCancel}>
        <FormattedMessage {...messages.cancelTextDescription} />
      </Button>
    </div>
  </Modal>
);

ConfirmationDialog.propTypes = {
  instructions: PropTypes.string,
  isOpen: PropTypes.bool,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
};



// WEBPACK FOOTER //
// ./components/claim/widgets/ConfirmationDialog.js